import React from 'react';

function ContactFormTextarea({
  alias,
  required,
  inputValues,
  handleChange,
  placeholder,
  pattern,
  errMsg,
  handleErrorText,
  maximumLength,
}) {
  const labelValue = required ? `${placeholder}*` : placeholder;
  const labelStyles = inputValues[alias].value
    ? 'top-0 -translate-y-full -translate-x-[12%] scale-75 left-0'
    : 'top-0 translate-y-3 left-4';
  const errMsgStyles = handleErrorText(inputValues[alias]) ? 'hidden' : 'inline';

  return (
    <div className="w-full h-auto relative">
      <textarea
        id={alias}
        name={alias}
        required={required}
        maxLength={maximumLength}
        className="w-full h-auto text-darkGrey text-base resize-none border border-greyCloud px-4
        py-1 min-h-[7.5rem] align-top"
        value={inputValues[alias].value}
        onChange={(event) => handleChange(event, pattern)}
      />
      <label
        htmlFor={alias}
        className={`absolute left-0 transition-all duration-300 text-darkGrey ${labelStyles}`}
      >
        {labelValue}
      </label>
      {errMsg && (
        <span className={`text-xs text-red absolute -bottom-5 left-0 ${errMsgStyles}`}>
          {errMsg}
        </span>
      )}
    </div>
  );
}

export default ContactFormTextarea;
